// German versions of the templates in components/examples.js and
// examplesPersonal.js. The templates are written once, in English; this
// maps every text in them to German, so a German board opens with German
// cards. Generated texts ("Squats 3/8", "Push-ups (round 2)", "Spaghetti
// (9 min)") are translated part by part via PATTERNS below.
// examples.test.js checks that every template text is covered.

// Names that are used as they are in German, too.
const SAME = [
  "1:1",
  "4Ls",
  "Brainstorming",
  "Burpees",
  "Check-in",
  "Check-out",
  "Crazy 8s",
  "Daily Scrum",
  "Design Sprint",
  "Energizer",
  "Feedback",
  "HIIT",
  "Input",
  "Input I",
  "Input II",
  "Lean Coffee",
  "Mountain Climbers",
  "Pasta",
  "Penne",
  "Basmati",
  "Q&A",
  "S",
  "M",
  "L",
  "XL",
  "Spaghetti",
  "Sprint Planning",
  "Sprint Review",
  "Sprint Retrospective",
  "Standard",
  "Steak",
  "Storyboard",
  "Supervote",
  "Tabata",
  "Updates",
  "Workshop",
  "Medium",
];

const TEXTS = {
  // Templates
  "Team Meeting": "Team-Meeting",
  "Decision Meeting": "Entscheidungs-Meeting",
  "All-Hands": "All-Hands-Meeting",
  "Pomodoro Timer": "Pomodoro-Timer",
  "Start, Stop, Continue": "Start, Stop, Continue",
  "Mad, Sad, Glad": "Mad, Sad, Glad",
  Sailboat: "Segelboot",
  "Talk with Q&A": "Vortrag mit Fragerunde",
  "Study Session": "Lerneinheit",
  "Project Kickoff": "Projekt-Kickoff",
  Rice: "Reis",
  "Tea & Coffee": "Tee & Kaffee",
  "Soft-boiled Eggs": "Weiche Eier",
  "Medium-boiled Eggs": "Wachsweiche Eier",
  "Hard-boiled Eggs": "Harte Eier",
  "Cleaning Sprint": "Putz-Sprint",
  Homework: "Hausaufgaben",
  "Morning Routine": "Morgenroutine",
  Meditation: "Meditation",
  "Power Nap": "Powernap",
  "Circuit Training": "Zirkeltraining",
  "Strength Training": "Krafttraining",
  "Run/Walk Intervals": "Lauf-Geh-Intervalle",
  Stretching: "Dehnen",

  // Descriptions
  "A regular team sync: quick check-in, updates, the topics that need the group, and clear action items.":
    "Der regelmäßige Team-Abgleich: kurzer Check-in, Updates, die Themen, die die ganze Gruppe brauchen, und klare Aufgaben.",
  "A one-on-one where the other person's topics come first, followed by feedback in both directions.":
    "Ein Einzelgespräch, in dem die Themen deines Gegenübers zuerst drankommen, danach Feedback in beide Richtungen.",
  "Get from options to a decision: shared context, questions, pros and cons, then decide and assign.":
    "Von Optionen zur Entscheidung: gemeinsamer Kontext, Fragen, Pro und Contra, dann entscheiden und verteilen.",
  "An agenda-less meeting: collect topics, vote, and discuss them in order with short timeboxes.":
    "Ein Meeting ohne feste Agenda: Themen sammeln, abstimmen und der Reihe nach in kurzen Timeboxen besprechen.",
  "A company or department meeting with updates, spotlights, recognition and open Q&A.":
    "Ein Firmen- oder Abteilungstreffen mit Updates, Einblicken in die Teams, Anerkennung und offener Fragerunde.",
  "Work in focused 25-minute Pomodoros with Short Breaks in between, a Long Break after every 4 Pomodoros, and a Lunch Break on longer days. Choose how long you want to work.":
    "Arbeite in konzentrierten 25-Minuten-Pomodoros mit kurzen Pausen dazwischen, einer langen Pause nach je 4 Pomodoros und einer Mittagspause an längeren Tagen. Wähl, wie lange du arbeiten willst.",
  "A simple, quick retro format: what to start doing, what to stop, and what to keep.":
    "Ein einfaches, schnelles Retro-Format: Was fangen wir an, was lassen wir, was behalten wir bei?",
  "A retro that starts from feelings: what made the team mad, sad or glad, and what to do about it.":
    "Eine Retro, die bei den Gefühlen ansetzt: Was hat das Team geärgert, traurig oder froh gemacht, und was tun wir damit?",
  "Liked, Learned, Lacked, Longed for - a balanced look back that also surfaces learning.":
    "Liked, Learned, Lacked, Longed for – ein ausgewogener Rückblick, der auch das Gelernte sichtbar macht.",
  "A visual retro: wind that pushes the team forward, anchors that hold it back, rocks ahead and the island it's heading for.":
    "Eine visuelle Retro: Wind, der das Team antreibt, Anker, die es bremsen, Felsen voraus und die Insel, auf die es zusteuert.",
  "A quick daily sync for the Developers - always 15 minutes, no matter how long the sprint is.":
    "Der kurze tägliche Abgleich der Developers – immer 15 Minuten, egal wie lang der Sprint ist.",
  "Agree the Sprint Goal, select Product Backlog items, and plan the work.":
    "Sprint-Ziel vereinbaren, Product-Backlog-Einträge auswählen und die Arbeit planen.",
  "Inspect the increment with stakeholders and adapt the Product Backlog.":
    "Das Inkrement mit den Stakeholdern überprüfen und das Product Backlog anpassen.",
  "Inspect how the last sprint went - people, process and tools - and plan improvements.":
    "Überprüfen, wie der letzte Sprint lief – Menschen, Prozesse und Werkzeuge – und Verbesserungen planen.",
  "A presentation followed by questions from the audience.":
    "Ein Vortrag mit anschließenden Fragen aus dem Publikum.",
  "Learn in focused blocks with breaks, then practise by recalling instead of re-reading.":
    "In konzentrierten Blöcken mit Pausen lernen, dann durch Abrufen statt erneutes Lesen üben.",
  "A classic workshop arc: goals and check-in, input, group work, sharing results, prioritising and next steps.":
    "Der klassische Workshop-Bogen: Ziele und Check-in, Input, Gruppenarbeit, Ergebnisse teilen, priorisieren und nächste Schritte.",
  "Start a project with a shared picture of the why, the goals, the scope, the roles and the road ahead.":
    "Starte ein Projekt mit einem gemeinsamen Bild vom Warum, den Zielen, dem Umfang, den Rollen und dem Weg dorthin.",
  "Generate many ideas first, then cluster and pick: silent ideation before discussion gets every voice in.":
    "Erst viele Ideen sammeln, dann clustern und auswählen: Stilles Ideensammeln vor der Diskussion holt jede Stimme ins Boot.",
  "The five-day Design Sprint, one agenda per day: map the problem, sketch solutions, decide, prototype and test with users.":
    "Der fünftägige Design Sprint, eine Agenda pro Tag: Problem kartieren, Lösungen skizzieren, entscheiden, Prototyp bauen und mit Nutzern testen.",
  "Cook until almost done, then taste and drain.":
    "Fast gar kochen, dann probieren und abgießen.",
  "Bring to a boil, simmer with the lid on, then let it rest.":
    "Aufkochen, mit Deckel köcheln lassen, dann ruhen lassen.",
  "For a 2.5 cm (1 inch) steak in a very hot pan, followed by a rest so the juices settle.":
    "Für ein 2,5 cm dickes Steak in einer sehr heißen Pfanne, danach ruhen lassen, damit sich der Fleischsaft setzt.",
  "Steeping times for a good cup.": "Ziehzeiten für eine gute Tasse.",
  "Runny yolk, just set white. For eggs straight from the fridge, lowered into boiling water - pick the size.":
    "Flüssiges Eigelb, gerade gestocktes Eiweiß. Für Eier direkt aus dem Kühlschrank, in kochendes Wasser gelegt – wähl die Größe.",
  "Jammy, creamy yolk. For eggs straight from the fridge, lowered into boiling water - pick the size.":
    "Cremiges, wachsweiches Eigelb. Für Eier direkt aus dem Kühlschrank, in kochendes Wasser gelegt – wähl die Größe.",
  "Firm yolk all the way through. For eggs straight from the fridge, lowered into boiling water - pick the size.":
    "Durchgehend festes Eigelb. Für Eier direkt aus dem Kühlschrank, in kochendes Wasser gelegt – wähl die Größe.",
  "Race the clock room by room - it's surprising how much fits into a timebox.":
    "Raum für Raum gegen die Uhr – erstaunlich, wie viel in eine Timebox passt.",
  "Plan, work in focused blocks with a break, and check at the end - for kids and students.":
    "Planen, in konzentrierten Blöcken mit Pause arbeiten und am Ende kontrollieren – für Schulkinder und Studierende.",
  "A calm start to the day without losing track of time.":
    "Ein ruhiger Start in den Tag, ohne die Zeit aus den Augen zu verlieren.",
  "Arrive, follow your breath, and gently come back.":
    "Ankommen, dem Atem folgen und sanft zurückkommen.",
  "A short nap to recharge - short enough not to wake up groggy.":
    "Ein kurzes Nickerchen zum Auftanken – kurz genug, um nicht benommen aufzuwachen.",
  "8 rounds of 20 seconds all-out and 10 seconds rest per block. One block is a quick 4-minute burst.":
    "8 Runden mit 20 Sekunden Vollgas und 10 Sekunden Pause pro Block. Ein Block ist ein schneller 4-Minuten-Sprint.",
  "High-intensity intervals with rest in between, rotating through five bodyweight exercises.":
    "Hochintensive Intervalle mit Pausen dazwischen, abwechselnd mit fünf Übungen mit dem eigenen Körpergewicht.",
  "Six exercises, 45 seconds each with 15 seconds to switch, a minute's break between rounds.":
    "Sechs Übungen, je 45 Sekunden mit 15 Sekunden zum Wechseln, eine Minute Pause zwischen den Runden.",
  "Sets of one minute with 90 seconds rest - enough time for 8-12 controlled reps.":
    "Sätze von einer Minute mit 90 Sekunden Pause – genug Zeit für 8–12 kontrollierte Wiederholungen.",
  "Alternate running and walking - a gentle way to start running or build up distance.":
    "Abwechselnd laufen und gehen – ein sanfter Einstieg ins Laufen oder um die Strecke zu steigern.",
  "A full-body stretch, one minute per position.":
    "Dehnen für den ganzen Körper, eine Minute pro Position.",

  // Variants
  "1-week sprint": "1-Wochen-Sprint",
  "2-week sprint": "2-Wochen-Sprint",
  "4-week sprint": "4-Wochen-Sprint",
  "Half day": "Halber Tag",
  "Full day": "Ganzer Tag",
  "Day 1: Map": "Tag 1: Kartieren",
  "Day 2: Sketch": "Tag 2: Skizzieren",
  "Day 3: Decide": "Tag 3: Entscheiden",
  "Day 4: Prototype": "Tag 4: Prototyp",
  "Day 5: Test": "Tag 5: Testen",
  "Fresh pasta": "Frische Pasta",
  "Long-grain": "Langkornreis",
  "Brown rice": "Naturreis",
  Rare: "Blutig",
  "Medium rare": "Medium rare",
  "Green tea": "Grüner Tee",
  "Black tea": "Schwarzer Tee",
  "Herbal tea": "Kräutertee",
  "French press": "French Press",
  Quick: "Schnell",
  Thorough: "Gründlich",
  Short: "Kurz",
  Long: "Lang",
  Classic: "Klassisch",
  "1 block": "1 Block",
  "4 blocks": "4 Blöcke",
  "30/30, 10 rounds": "30/30, 10 Runden",
  "40/20, 15 rounds": "40/20, 15 Runden",
  "2 rounds": "2 Runden",
  "3 rounds": "3 Runden",
  "4 rounds": "4 Runden",
  "Full body, 3 sets": "Ganzkörper, 3 Sätze",
  "Upper body, 3 sets": "Oberkörper, 3 Sätze",
  "Beginner: run 3, walk 2": "Einstieg: 3 laufen, 2 gehen",
  "Next level: run 6, walk 1": "Nächste Stufe: 6 laufen, 1 gehen",
  "Full body": "Ganzkörper",

  // Cards
  Topics: "Themen",
  "Action Items": "Aufgaben",
  "Topic 1": "Thema 1",
  "Topic 2": "Thema 2",
  "Topic 3": "Thema 3",
  "Topic 4": "Thema 4",
  "Topic 5": "Thema 5",
  "Their Topics": "Themen des Gegenübers",
  "Next Steps": "Nächste Schritte",
  "Context & Options": "Kontext & Optionen",
  "Clarifying Questions": "Verständnisfragen",
  "Pros & Cons": "Pro & Contra",
  Decide: "Entscheiden",
  "Collect Topics": "Themen sammeln",
  "Dot Vote": "Punkten",
  "Wrap Up": "Abschluss",
  Welcome: "Begrüßung",
  "Team Spotlights": "Einblicke in die Teams",
  Recognition: "Anerkennung",
  Close: "Ausklang",
  Focus: "Fokus",
  "Short Break": "Kurze Pause",
  "Long Break": "Lange Pause",
  "Lunch Break": "Mittagspause",
  "Set the Stage": "Ankommen",
  "Write Cards": "Karten schreiben",
  "Share & Cluster": "Vorstellen & clustern",
  "Pick Actions": "Maßnahmen wählen",
  "Dig into Top Topics": "Top-Themen vertiefen",
  Share: "Vorstellen",
  Discuss: "Besprechen",
  "Draw the Boat": "Boot zeichnen",
  "Agree the Sprint Goal": "Sprint-Ziel vereinbaren",
  "Select Backlog Items": "Backlog-Einträge auswählen",
  "Plan the Work": "Arbeit planen",
  "Recap the Sprint Goal": "Sprint-Ziel rekapitulieren",
  "Demo the Increment": "Inkrement vorführen",
  "Stakeholder Feedback": "Feedback der Stakeholder",
  "Update the Product Backlog": "Product Backlog anpassen",
  "Gather Data": "Daten sammeln",
  "Generate Insights": "Erkenntnisse gewinnen",
  "Decide What to Do": "Maßnahmen beschließen",
  "Close the Retro": "Retro abschließen",
  Talk: "Vortrag",
  "Plan the Session": "Lerneinheit planen",
  Learn: "Lernen",
  "Practise & Recall": "Üben & abrufen",
  Review: "Wiederholen",
  "Welcome & Goals": "Begrüßung & Ziele",
  "Group Work": "Gruppenarbeit",
  "Group Work I": "Gruppenarbeit I",
  "Group Work II": "Gruppenarbeit II",
  Break: "Pause",
  "Share Results": "Ergebnisse vorstellen",
  Prioritise: "Priorisieren",
  "Share & Prioritise": "Vorstellen & priorisieren",
  "Welcome & Intros": "Begrüßung & Vorstellungsrunde",
  "Goals & Scope": "Ziele & Umfang",
  "Roles & Responsibilities": "Rollen & Verantwortlichkeiten",
  "Timeline & Milestones": "Zeitplan & Meilensteine",
  "Risks & Open Questions": "Risiken & offene Fragen",
  "Welcome & Check-in": "Begrüßung & Check-in",
  "Why This Project": "Warum dieses Projekt",
  "Goals & Success Criteria": "Ziele & Erfolgskriterien",
  "Scope: In & Out": "Umfang: drin & draußen",
  "Roles & Ways of Working": "Rollen & Zusammenarbeit",
  Risks: "Risiken",
  "Next Steps & Check-out": "Nächste Schritte & Check-out",
  "Frame the Question": "Frage formulieren",
  "Frame the Challenge": "Herausforderung formulieren",
  "Silent Ideation": "Stilles Ideensammeln",
  "Share Ideas": "Ideen vorstellen",
  Cluster: "Clustern",
  "Warm-up": "Aufwärmen",
  "Build on Ideas": "Ideen weiterentwickeln",
  "Long-term Goal": "Langfristiges Ziel",
  "Sprint Questions": "Sprint-Fragen",
  "Make a Map": "Karte erstellen",
  "Ask the Experts": "Expertenbefragung",
  "Organise HMW Notes": "„Wie könnten wir“-Notizen ordnen",
  "Pick a Target": "Ziel auswählen",
  "Lightning Demos": "Lightning Demos",
  "Divide or Swarm": "Aufteilen oder gemeinsam",
  Notes: "Notizen",
  Ideas: "Ideen",
  "Solution Sketch": "Lösungsskizze",
  "Recruit Testers": "Testpersonen anwerben",
  "Art Museum": "Kunstausstellung",
  "Heat Map": "Heatmap",
  "Speed Critique": "Schnellkritik",
  "Straw Poll": "Probeabstimmung",
  "Assign Roles": "Rollen verteilen",
  "Build the Prototype": "Prototyp bauen",
  "Finish the Prototype": "Prototyp fertigstellen",
  "Trial Run": "Probelauf",
  "Interview 1": "Interview 1",
  "Interview 2": "Interview 2",
  "Interview 3": "Interview 3",
  "Interview 4": "Interview 4",
  "Interview 5": "Interview 5",
  "Debrief & Next Steps": "Auswertung & nächste Schritte",
  "Cook spaghetti": "Spaghetti kochen",
  "Taste & drain": "Probieren & abgießen",
  "Cook penne": "Penne kochen",
  "Cook fresh pasta": "Frische Pasta kochen",
  "Bring to a boil": "Aufkochen",
  "Simmer covered": "Mit Deckel köcheln",
  "Rest off the heat": "Neben dem Herd ruhen lassen",
  "First side": "Erste Seite",
  "Flip: second side": "Wenden: zweite Seite",
  Rest: "Pause",
  "Steep green tea": "Grüner Tee zieht",
  "Steep black tea": "Schwarzer Tee zieht",
  "Steep herbal tea": "Kräutertee zieht",
  Bloom: "Vorquellen",
  Steep: "Ziehen lassen",
  "Tidy up": "Aufräumen",
  Kitchen: "Küche",
  Bathroom: "Bad",
  "Living room": "Wohnzimmer",
  Vacuum: "Staubsaugen",
  Plan: "Planen",
  "Task 1": "Aufgabe 1",
  "Task 2": "Aufgabe 2",
  Check: "Kontrollieren",
  "Wake up & drink water": "Aufwachen & Wasser trinken",
  Stretch: "Dehnen",
  Shower: "Duschen",
  "Get dressed": "Anziehen",
  Breakfast: "Frühstück",
  Arrive: "Ankommen",
  Breathe: "Atmen",
  Return: "Zurückkommen",
  Nap: "Nickerchen",
  "Block break": "Blockpause",
  "Cool-down": "Cool-down",
  "Round break": "Rundenpause",
  "Warm-up walk": "Einlaufen im Gehen",
  Walk: "Gehen",
  "Cool-down walk": "Auslaufen im Gehen",
  Neck: "Nacken",
  Shoulders: "Schultern",
  Chest: "Brust",
  "Hamstrings left": "Oberschenkelrückseite links",
  "Hamstrings right": "Oberschenkelrückseite rechts",
  "Quads left": "Oberschenkelvorderseite links",
  "Quads right": "Oberschenkelvorderseite rechts",
  Hips: "Hüfte",
  Calves: "Waden",
  "Lower Back": "Unterer Rücken",
  "Soft-boiled egg": "Weiches Ei",
  "Medium-boiled egg": "Wachsweiches Ei",
  "Hard-boiled egg": "Hartes Ei",
  // Exercises in generated cards
  "Jumping Jacks": "Hampelmänner",
  Squats: "Kniebeugen",
  "Push-ups": "Liegestütze",
  Lunges: "Ausfallschritte",
  "High Knees": "Kniehebelauf",
  Plank: "Unterarmstütz",
  Rows: "Rudern",
  "Glute Bridges": "Beckenheben",
  "Shoulder Press": "Schulterdrücken",
  Run: "Laufen",

  // Notes
  "One minute per person, details go to the topics":
    "Eine Minute pro Person, Details kommen zu den Themen",
  "Who does what by when": "Wer macht was bis wann",
  "Their agenda first, yours second":
    "Erst die Agenda deines Gegenübers, dann deine",
  "Both directions": "In beide Richtungen",
  "Questions only, no opinions yet": "Nur Fragen, noch keine Meinungen",
  "Agree on the rule first: consent, majority or the owner decides":
    "Erst die Regel klären: Konsent, Mehrheit oder die verantwortliche Person entscheidet",
  "One topic per sticky note": "Ein Thema pro Haftnotiz",
  "Two or three dots each": "Zwei oder drei Punkte pro Person",
  "Thumbs vote at the end: keep going or next topic":
    "Am Ende Daumenabstimmung: weitermachen oder nächstes Thema",
  "Collect questions in advance as well": "Fragen auch vorab sammeln",
  "Start / Stop / Continue, one idea per card":
    "Start / Stop / Continue, eine Idee pro Karte",
  "Two or three, each with an owner":
    "Zwei oder drei, jeweils mit verantwortlicher Person",
  "Mad / Sad / Glad": "Mad / Sad / Glad",
  "Liked / Learned / Lacked / Longed for":
    "Liked / Learned / Lacked / Longed for",
  "Wind / Anchors / Rocks / Island": "Wind / Anker / Felsen / Insel",
  "What should you be able to do afterwards?":
    "Was sollst du danach können?",
  "Close the book, write down what you remember":
    "Buch zu, aufschreiben, was du noch weißt",
  "Groups of 3-5, one question each": "Gruppen zu 3–5, je eine Frage",
  "Max. 5 minutes per group": "Max. 5 Minuten pro Gruppe",
  "What we explicitly won't do matters as much":
    "Was wir ausdrücklich nicht tun, ist genauso wichtig",
  'Phrase it as "How might we ...?"': "Als „Wie könnten wir ...?“ formulieren",
  "Alone, one idea per sticky note": "Allein, eine Idee pro Haftnotiz",
  '"Yes, and ..." - combine and extend':
    "„Ja, und ...“ – kombinieren und erweitern",
  'Everyone writes "How might we" notes':
    "Alle schreiben „Wie könnten wir“-Notizen",
  "Eight variations in eight minutes": "Acht Varianten in acht Minuten",
  "Hang up all sketches": "Alle Skizzen aufhängen",
  "The Decider decides": "Die entscheidende Person entscheidet",
  "Salt the boiling water first, stir after a minute":
    "Erst das kochende Wasser salzen, nach einer Minute umrühren",
  "Keep a cup of pasta water": "Eine Tasse Nudelwasser aufheben",
  "1 part rice, 1.5 parts water": "1 Teil Reis, 1,5 Teile Wasser",
  "Lowest heat, don't lift the lid":
    "Kleinste Stufe, Deckel nicht anheben",
  "1 part rice, 2 parts water": "1 Teil Reis, 2 Teile Wasser",
  "1 part rice, 2.5 parts water": "1 Teil Reis, 2,5 Teile Wasser",
  "Don't move it": "Nicht bewegen",
  "On a warm plate": "Auf einem warmen Teller",
  "Water at 75-80 °C": "Wasser mit 75–80 °C",
  "Boiling water": "Kochendes Wasser",
  "Boiling water, lid on": "Kochendes Wasser, Deckel drauf",
  "Pour a little water, let the coffee swell":
    "Etwas Wasser aufgießen, den Kaffee quellen lassen",
  "Top up, lid on, then press slowly":
    "Auffüllen, Deckel drauf, dann langsam herunterdrücken",
  "Lower into boiling water, then rinse under cold water":
    "In kochendes Wasser legen, danach kalt abschrecken",
  "What needs doing today?": "Was steht heute an?",
  "Is everything packed for tomorrow?": "Ist alles für morgen eingepackt?",
  "Sit comfortably, close your eyes":
    "Bequem hinsetzen, Augen schließen",
  "Follow your breath; when the mind wanders, come back":
    "Dem Atem folgen; wenn die Gedanken abschweifen, zurückkommen",
  "Notice the room, open your eyes": "Den Raum wahrnehmen, Augen öffnen",
  "Turn sound alerts on so the end wakes you":
    "Signaltöne einschalten, damit dich das Ende weckt",
  "March on the spot, arm circles, easy squats":
    "Auf der Stelle marschieren, Armkreisen, lockere Kniebeugen",
  "Walk it out, stretch": "Locker gehen, dehnen",
  "Feet shoulder-width, sit back":
    "Füße schulterbreit, Po nach hinten schieben",
  "On your knees is fine": "Auf den Knien ist völlig okay",
  "Alternate legs": "Beine abwechseln",
  "Straight line from head to heels":
    "Gerade Linie vom Kopf bis zu den Fersen",
  "Step back instead of jumping if needed":
    "Bei Bedarf zurücksteigen statt springen",
  "Keep the hips low": "Hüfte unten halten",
  "8-12 controlled reps": "8–12 kontrollierte Wiederholungen",
  "Easy pace - you should still be able to talk":
    "Lockeres Tempo – du solltest dich noch unterhalten können",
  "Ear to shoulder, both sides": "Ohr zur Schulter, beide Seiten",
  "Arm across the chest, both sides":
    "Arm vor der Brust herziehen, beide Seiten",
  "Hands clasped behind the back": "Hände hinter dem Rücken verschränken",
  "Straight leg, reach for the toes":
    "Bein gestreckt, Richtung Zehen greifen",
  "Heel to the bottom": "Ferse zum Po",
  "Deep lunge, sink the hips": "Tiefer Ausfallschritt, Hüfte absenken",
  "Against a wall, heel down": "An der Wand, Ferse am Boden",
  "Lying down, knees to the chest": "Im Liegen die Knie zur Brust",

  // Yeast doughs
  "Pizza (Pizza Stone)": "Pizza (Pizzastein)",
  Focaccia: "Focaccia",
  "Bread Rolls": "Brötchen",
  "Braided Loaf (Hefezopf)": "Hefezopf",
  "Cinnamon Rolls": "Zimtschnecken",
  "Yeast Sheet Cake": "Hefeblechkuchen",
  "Four pizzas baked one after another on a hot stone - from fresh dough, cold-proofed dough or dough that's ready.":
    "Vier Pizzen nacheinander auf dem heißen Stein gebacken – aus frischem Teig, kalt geführtem Teig oder fertigem Teig.",
  "A soft, airy flatbread in a tray, dimpled and drizzled with olive oil.":
    "Ein weiches, luftiges Fladenbrot vom Blech, mit Mulden und Olivenöl.",
  "Crisp rolls - a pizza stone and a little steam make the crust.":
    "Knusprige Brötchen – Pizzastein und etwas Dampf machen die Kruste.",
  "A sweet braided yeast loaf - classic for breakfast.":
    "Ein süßer geflochtener Hefezopf – der Klassiker zum Frühstück.",
  "Soft rolls with a cinnamon-sugar swirl and a glaze.":
    "Weiche Schnecken mit Zimtzucker-Füllung und Guss.",
  "A tray of Butterkuchen, Streuselkuchen or plum cake on a yeast base.":
    "Ein Blech Butterkuchen, Streuselkuchen oder Zwetschgenkuchen auf Hefeteig.",
  "Same-day dough": "Teig vom selben Tag",
  "Quick dough": "Schneller Teig",
  "From the fridge": "Aus dem Kühlschrank",
  "Bake only, 4 pizzas": "Nur backen, 4 Pizzen",
  "Bake only, 6 pizzas": "Nur backen, 6 Pizzen",
  Tray: "Blech",
  "10 rolls": "10 Brötchen",
  "1 loaf": "1 Zopf",
  "12 rolls": "12 Schnecken",
  "1 tray": "1 Blech",
  "Activate the yeast": "Hefe aktivieren",
  "Mix & knead": "Mischen & kneten",
  "First rise": "Erste Gare",
  "Second rise - preheat oven now": "Zweite Gare – jetzt Ofen vorheizen",
  "Proof - preheat oven now": "Stückgare – jetzt Ofen vorheizen",
  "Proof balls - preheat stone now": "Teiglinge gehen lassen – jetzt Stein vorheizen",
  "Divide & shape balls": "Teilen & Kugeln formen",
  "Dough warms up": "Teig temperieren",
  "Preheat the stone": "Stein vorheizen",
  "Stretch & top pizza 1": "Pizza 1 ausziehen & belegen",
  "Bake pizza": "Pizza backen",
  "Stone heats back up": "Stein heizt nach",
  "Into the oiled tray": "Aufs geölte Blech",
  "Dimple & top": "Mulden drücken & belegen",
  Bake: "Backen",
  "Cool on a rack": "Auf dem Gitter abkühlen",
  "Shape rolls": "Brötchen formen",
  "Shape & braid": "Formen & flechten",
  "Glaze & bake": "Bestreichen & backen",
  Cool: "Abkühlen",
  "Roll, fill & cut": "Ausrollen, füllen & schneiden",
  "Cool a little": "Etwas abkühlen",
  Glaze: "Glasieren",
  "Roll out & top": "Ausrollen & belegen",
  "Stir 3 g dry or 10 g fresh yeast and 1 tsp sugar into 325 ml lukewarm water (about 37 °C - hot water kills the yeast). Wait until it foams; if nothing happens, the yeast is too old.":
    "3 g Trocken- oder 10 g frische Hefe und 1 TL Zucker in 325 ml lauwarmes Wasser rühren (etwa 37 °C – heißes Wasser tötet die Hefe). Warten, bis es schäumt; passiert nichts, ist die Hefe zu alt.",
  "Stir 7 g dry or 21 g fresh yeast and 1 tsp sugar into 325 ml lukewarm water (about 37 °C - hot water kills the yeast). Wait until it foams; if nothing happens, the yeast is too old.":
    "7 g Trocken- oder 21 g frische Hefe und 1 TL Zucker in 325 ml lauwarmes Wasser rühren (etwa 37 °C – heißes Wasser tötet die Hefe). Warten, bis es schäumt; passiert nichts, ist die Hefe zu alt.",
  "Pour the yeast water onto 500 g flour (Tipo 00), add 10 g salt and 1 tbsp olive oil (salt not directly onto the yeast). Optional: 1-2 tsp herbes de Provence. Knead until smooth and elastic - it should spring back when pressed.":
    "Das Hefewasser auf 500 g Mehl (Tipo 00) gießen, 10 g Salz und 1 EL Olivenöl dazu (Salz nicht direkt auf die Hefe). Optional: 1–2 TL Kräuter der Provence. Kneten, bis der Teig glatt und elastisch ist – auf Druck soll er zurückfedern.",
  "500 g flour, 400 ml lukewarm water, 10 g salt, 7 g dry yeast, 2 tbsp olive oil - the dough stays sticky":
    "500 g Mehl, 400 ml lauwarmes Wasser, 10 g Salz, 7 g Trockenhefe, 2 EL Olivenöl – der Teig bleibt klebrig",
  "500 g flour (type 550), 300 ml lukewarm water, 10 g salt, 7 g dry yeast, 1 tsp sugar":
    "500 g Mehl (Type 550), 300 ml lauwarmes Wasser, 10 g Salz, 7 g Trockenhefe, 1 TL Zucker",
  "500 g flour, 250 ml lukewarm milk, 80 g sugar, 80 g soft butter, 1 egg, 1 pinch of salt, 7 g dry yeast":
    "500 g Mehl, 250 ml lauwarme Milch, 80 g Zucker, 80 g weiche Butter, 1 Ei, 1 Prise Salz, 7 g Trockenhefe",
  "500 g flour, 250 ml lukewarm milk, 60 g sugar, 80 g soft butter, 1 egg, 1 pinch of salt, 7 g dry yeast":
    "500 g Mehl, 250 ml lauwarme Milch, 60 g Zucker, 80 g weiche Butter, 1 Ei, 1 Prise Salz, 7 g Trockenhefe",
  "500 g flour, 250 ml lukewarm milk, 75 g sugar, 75 g soft butter, 1 egg, 1 pinch of salt, 7 g dry yeast":
    "500 g Mehl, 250 ml lauwarme Milch, 75 g Zucker, 75 g weiche Butter, 1 Ei, 1 Prise Salz, 7 g Trockenhefe",
  "Press from the middle outwards, leave the rim. Semolina on the peel so it slides.":
    "Von der Mitte nach außen drücken, den Rand stehen lassen. Grieß auf den Pizzaschieber, damit sie rutscht.",
  "Slide onto the stone, turn after 4 min.":
    "Auf den Stein gleiten lassen, nach 4 Min. drehen.",
  "Slide onto the stone, turn after 4 min. Meanwhile stretch & top the next one.":
    "Auf den Stein gleiten lassen, nach 4 Min. drehen. Währenddessen die nächste ausziehen & belegen.",
  "Close the oven door - slice and enjoy":
    "Ofentür schließen – aufschneiden und genießen",
  "Stone on the middle rack, oven at its hottest (250-300 °C)":
    "Stein auf die mittlere Schiene, Ofen auf höchste Stufe (250–300 °C)",
  "Stone on the middle rack, oven at its hottest (250-300 °C). Balls covered so they don't dry out.":
    "Stein auf die mittlere Schiene, Ofen auf höchste Stufe (250–300 °C). Teiglinge abdecken, damit sie nicht austrocknen.",
  "4 balls of about 210 g, tuck the dough underneath until taut":
    "4 Kugeln à etwa 210 g, den Teig nach unten einschlagen, bis er straff ist",
  "Covered, at room temperature, until doubled":
    "Abgedeckt bei Zimmertemperatur, bis sich das Volumen verdoppelt hat",
  "Covered, in a warm place, until doubled":
    "Abgedeckt an einem warmen Ort, bis sich das Volumen verdoppelt hat",
  "Covered, until doubled": "Abgedeckt, bis sich das Volumen verdoppelt hat",
  "Covered, until doubled and bubbly":
    "Abgedeckt, bis sich das Volumen verdoppelt hat und der Teig Blasen wirft",
  "Take the cold-proofed balls out of the fridge, keep them covered":
    "Die kalt geführten Teiglinge aus dem Kühlschrank nehmen, abgedeckt lassen",
  "Gently stretch towards the corners": "Vorsichtig in die Ecken ziehen",
  "Oven at 230 °C top/bottom heat": "Ofen auf 230 °C Ober-/Unterhitze",
  "Oven at 180 °C top/bottom heat": "Ofen auf 180 °C Ober-/Unterhitze",
  "Oily fingers deep into the dough, olive oil, flaky salt, rosemary":
    "Mit geölten Fingern tiefe Mulden drücken, Olivenöl, Salzflocken, Rosmarin",
  "Until golden brown": "Bis sie goldbraun ist",
  "So the bottom stays crisp": "Damit der Boden knusprig bleibt",
  "10 pieces, shape into tight balls, score the tops":
    "10 Stücke, straff rundwirken, oben einschneiden",
  "Stone or tray in the oven at 230 °C; a heatproof dish on the bottom for water":
    "Stein oder Blech in den Ofen bei 230 °C; eine ofenfeste Schale für Wasser auf den Boden",
  "Pour a cup of water into the dish for steam, close the door quickly":
    "Eine Tasse Wasser in die Schale gießen für Dampf, Tür schnell schließen",
  "Three strands, braid from the middle out, onto a lined tray":
    "Drei Stränge, von der Mitte aus flechten, aufs belegte Blech",
  "Brush with egg yolk and milk, sprinkle pearl sugar. Cover with foil if it browns too fast.":
    "Mit Eigelb und Milch bestreichen, Hagelzucker darüber. Mit Folie abdecken, falls er zu schnell braun wird.",
  "On a rack, before slicing": "Auf dem Gitter, vor dem Anschneiden",
  "Roll out, spread with 80 g butter, 100 g brown sugar, 2 tbsp cinnamon; roll up, cut 12 slices":
    "Ausrollen, mit 80 g Butter, 100 g braunem Zucker und 2 EL Zimt bestreichen; aufrollen, in 12 Scheiben schneiden",
  "Into the tin, covered; oven at 180 °C top/bottom heat":
    "In die Form, abgedeckt; Ofen auf 180 °C Ober-/Unterhitze",
  "Until lightly golden": "Bis sie leicht golden sind",
  "Icing sugar with a little milk or cream cheese":
    "Puderzucker mit etwas Milch oder Frischkäse",
  "Onto a lined tray. Butter flakes and sugar, streusel, or halved plums.":
    "Aufs belegte Blech. Butterflöckchen und Zucker, Streusel oder halbierte Zwetschgen.",
  "Until golden": "Bis er golden ist",
  "On the tray, then cut into squares":
    "Auf dem Blech, dann in Stücke schneiden",
};

SAME.forEach((text) => {
  TEXTS[text] = text;
});

// "1.5h" -> "1,5h", "2 hours" -> "2 Stunden"; "45 min", "1h 30m" and
// "5m 30s" are read the same way in German.
function translateDuration(text) {
  if (!/^[\d.]+\s*(h|m|s|min|hours?)?(\s+[\d.]+\s*(h|m|s|min))?$/.test(text)) {
    return null;
  }
  return text
    .replace(/(\d)\.(\d)/g, "$1,$2")
    .replace(/^1 hour$/, "1 Stunde")
    .replace(/ hours$/, " Stunden");
}

const PATTERNS = [
  // Kneading notes: "<ingredients>. Knead until smooth and elastic."
  [
    /^(.+)\. (Knead until smooth and elastic\.)$/,
    (ingredients) =>
      `${ingredients}. Kneten, bis der Teig glatt und elastisch ist.`,
  ],
  // "Squats 3/8", "Run 2/5"
  [/^(.+) (\d+\/\d+)$/, (name, count) => `${name} ${count}`],
  // "Push-ups (round 2)"
  [/^(.+) \(round (\d+)\)$/, (name, round) => `${name} (Runde ${round})`],
  // "Rows - set 1/3"
  [/^(.+) - set (\d+\/\d+)$/, (name, set) => `${name} – Satz ${set}`],
];

// The German text for a template text, or null if there is none.
export function translateTemplateText(text) {
  if (Object.prototype.hasOwnProperty.call(TEXTS, text)) {
    return TEXTS[text];
  }
  const duration = translateDuration(text);
  if (duration) {
    return duration;
  }
  for (const [pattern, build] of PATTERNS) {
    const match = text.match(pattern);
    const name = match && translateTemplateText(match[1]);
    if (name) {
      return build(name, match[2]);
    }
  }
  // "Spaghetti (9 min)", "Half day (3h)", "Soft-boiled egg (M)"
  const withSuffix = text.match(/^(.+) \(([^()]+)\)$/);
  if (withSuffix) {
    const name = translateTemplateText(withSuffix[1]);
    const suffix =
      translateDuration(withSuffix[2]) ?? translateTemplateText(withSuffix[2]);
    if (name && suffix) {
      return `${name} (${suffix})`;
    }
  }
  return null;
}

const toGerman = (text) => (text ? translateTemplateText(text) ?? text : text);

// The templates in the given language (they are written in English).
export function localizeExamples(examples, language) {
  if (language !== "de") {
    return examples;
  }
  return examples.map((example) => ({
    ...example,
    event: toGerman(example.event),
    description: toGerman(example.description),
    variants: example.variants.map((variant) => ({
      ...variant,
      label: toGerman(variant.label),
      agenda: variant.agenda.map((card) => ({
        ...card,
        topic: toGerman(card.topic),
        note: toGerman(card.note),
      })),
    })),
  }));
}
